import styled from "styled-components";
import { colors } from "@streeteasy/design-system";

import AgentBannerBase from "../AgentBanner";
import AgentExperienceBase from "../AgentExperience";
import SimilarHomesBase from "../SimilarHomes";

const { GRAY_LIGHT } = colors;

export const Container = styled.div`
  align-items: center;
  border-bottom: 1px solid ${GRAY_LIGHT};
  border-top: 1px solid ${GRAY_LIGHT};
  display: flex;
  flex-direction: column;
  margin-top: 12px;
`;

export const AgentBanner = styled(AgentBannerBase)`
  margin-bottom: -12px;
  margin-top: -12px;
`;

export const SimilarHomes = styled(SimilarHomesBase)`
  margin: 21px 0 16px;
  min-width: 330px;
`;

export const AgentExperience = styled(AgentExperienceBase)`
  align-self: flex-start;
  border-top: 1px solid ${GRAY_LIGHT};
  padding-top: 16px;
  width: 100%;
`;
